import React, { useEffect, useRef, useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import config from "../../config";
import ScrollContainer from "react-indiana-drag-scroll";
import { formatDateWithTimeYear, formatFullDate } from "../../utils/dateFormat";
import Paginator from "../../shared/Paginator";
import { useNavigate } from "react-router";
import { CSVLink } from "react-csv";
import TableLoader from "../../shared/TableLoader";
import { SlIcon, SlTooltip, } from '@shoelace-style/shoelace/dist/react';

function InboundVernacular() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [currentpage, setCurrentPage] = useState(0);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const now = new Date();
  const [dateRange, setDateRange] = useState({
    startDate: formatFullDate(now),
    endDate: formatFullDate(now),
  });
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [downloadData, setDownloadData] = useState([]);
  const csvLinkRef = useRef(); // Create a ref for CSVLink

  let csvHeaders = [
    { label: "S.No", key: "sno" },
    { label: "Source", key: "source" },
    { label: "Name", key: "name" },
    { label: "Email", key: "mail" },
    { label: "Mobile", key: "mobile" },
    { label: "Company", key: "company" },
    { label: "Designation", key: "disignation" },
    { label: "Time", key: "contact_time" },
  ];

  const loadData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/vernacular/get",
        method: "POST",
        responseType: "json",
        data: {
          page: currentpage,
          limit: config.PER_PAGE,
          dateRange,
        },
      });
      if (res.code === 200) {
        setData(res.data?.data || []);
        setTotalPages(Math.round(res.data?.total / config.PER_PAGE));
      } else if (res.code === 401) navigate("/");
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };
  const getdownloadData = async () => {
    try {
      setDownloadLoader(true);
      let res = await API({
        url: "/vernacular/download",
        method: "POST",
        responseType: "json",
        data: {
          dateRange,
        },
      });
      if (res.code === 200) {
        setDownloadData(res.data?.data || []);
      } else if (res.code === 401) navigate("/");
      setDownloadLoader(false);
    } catch (error) {
      console.error("Error @ downloadDate", error);
    }
  };
  useEffect(() => {
    loadData();
  }, [dateRange, currentpage]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  const handleValueChange = (newValue) => {
    setCurrentPage(0)
    setDateRange(newValue);
  };
  useEffect(() => {
    if (downloadData.length) {
      csvLinkRef?.current?.link?.click();
      setDownloadData([]);
    }
  }, [downloadData]);
  return (
    <>
      <div className="justify-between flex my-2">
        <h5>Vernacular Data</h5>
        <aside className="flex gap-3 items-end">
          <div className="border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66">
            <Datepicker
              classNames="form-input"
              value={dateRange}
              primaryColor={"cyan"}
              showShortcuts={true}
              // useRange={false}
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={handleValueChange}
            />
          </div>
          <div className="ml-auto">
            <CSVLink
              data={downloadData.map(
                ({
                  sno,
                  source,
                  name,
                  mail,
                  mobile,
                  company,
                  disignation,
                  contact_time,
                }) => {
                  let obj = {
                    sno,
                    source,
                    name,
                    mail,
                    mobile,
                    company,
                    disignation,
                    contact_time: formatDateWithTimeYear(contact_time),
                  };
                  return obj;
                }
              )}
              headers={csvHeaders}
              filename={`vernacular_reports${dateRange.startDate ? `_${dateRange.startDate}-${dateRange.endDate}` : ''}.csv`}
              ref={csvLinkRef} // Assign the ref to the CSVLink component
            ></CSVLink>

            {downloadLoader ? (
              <TableLoader />
            ) : (
              <SlTooltip content="Download LineItem Reports">
                <SlIcon
                  library="lucide"
                  name="download"
                  className="w-6 h-6"
                  onClick={() => {
                    getdownloadData();
                  }}
                ></SlIcon>
              </SlTooltip>
            )}
          </div>
        </aside>
      </div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead className="bg-gray-50">
            <tr>
              <th>S.No</th>
              <th>Source</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Company</th>
              <th>Designation</th>
              <th>Time</th>
            </tr>
          </thead>
          {!loader && data?.length > 0 ? (
            <tbody className="help">
              {data.map((item, index) => (
                <tr key={index}>
                  {/* <td>{(+currentpage*+config.PER_PAGE)+index+1}</td> */}
                  <td>{item.sno}</td>
                  <td>{item.source}</td>
                  <td>{item.name}</td>
                  <td>{item.mail}</td>
                  <td>{item.mobile}</td>
                  <td>{item.company}</td>
                  <td>{item.disignation}</td>
                  <td>{formatDateWithTimeYear(item.contact_time)}</td>
                </tr>
              ))}
            </tbody>
          ) : loader ? (
            <TableSkelton colspan={8} />
          ) : (
            <NoDataFound colspan={8} />
          )}
        </table>
      </ScrollContainer>
      <div className=" right-fixed mt-4">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentpage}
          />
        )}
      </div>
    </>
  );
}

export default InboundVernacular;
